import actionTypes from '../../actions/bill/transfer/actionType';

const initialState = {
  modalVisible: false,
  roomsLoading: false,
  rooms: [], // 房间列表
  roomTypes: [], // 房型列表
  selectedRoom: null, // 选中的房间
  selectedRoomId: 0, // 选中的房间id
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.TOGGLE_TRANSFER_MODAL_VISIBLE:
      const { modalVisible } = payload;
      return {
        ...state,
        modalVisible,
      };

    case actionTypes.SET_TARGETS_LOADING:
      const { roomsLoading } = payload;
      return {
        ...state,
        roomsLoading,
      };
    case actionTypes.SET_TARGET_ROOMS:
      const { rooms } = payload;
      return {
        ...state,
        rooms,
      };
    case actionTypes.SET_TARGET_ROOMTYPES:
      const { roomTypes } = payload;
      return {
        ...state,
        roomTypes,
      };
    case actionTypes.RESET_TARGETS:
      return {
        ...state,
        rooms: [],
        roomTypes: [],
      };

    case actionTypes.SET_SELECTED_TARGET_ROOM:
      const { selectedRoom } = payload;
      return {
        ...state,
        selectedRoom,
      };
    case actionTypes.SET_SELECTED_TARGET_ROOM_ID:
      const { selectedRoomId } = payload;
      return {
        ...state,
        selectedRoomId,
      };
    default:
      return state;
  }
};
